import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { updateAutoApproveVerifiedModels } from '@/api/model-management';
import useWorkspacesStore from '@/state/workspaces.state';
import { useGlobalStore } from '@/state/global.state';
import { I18N_KEYS } from '@/language/keys';
import { log } from '@/logger/logger';

const logger = log.getLogger('useModelManagement');

export const useUpdateAutoApprove = () => {
  const { t } = useTranslation();
  const activeWorkspace = useWorkspacesStore((state) => state.activeWorkspace);
  const updateActiveWorkspace = useWorkspacesStore((state) => state.updateActiveWorkspace);
  const { updateSnackbarData } = useGlobalStore();

  return useMutation({
    mutationFn: (checked: boolean) => updateAutoApproveVerifiedModels(activeWorkspace.workspaceId, checked),
    onMutate: (checked: boolean) => {
      const previousValue = activeWorkspace.preferences?.shouldAutoApproveVerifiedModels ?? false;
      updateActiveWorkspace({
        preferences: { ...activeWorkspace.preferences, shouldAutoApproveVerifiedModels: checked },
      });
      return { previousValue };
    },
    onError: (_err, _checked, context) => {
      logger.error('Error updating auto-approve verified models preference', _err);
      updateActiveWorkspace({
        preferences: { ...activeWorkspace.preferences, shouldAutoApproveVerifiedModels: context?.previousValue },
      });
      updateSnackbarData({
        text: t(I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.AUTO_APPROVE_VERIFIED.ERROR),
        isOpen: true,
        icon: null,
        severity: 'error',
      });
    },
  });
};
